import React from 'react'
import ReactDOM from 'react-dom'
import AdGlobalPopad from '@Components/ad/AdGlobalPopad'

const adBlackList = [
  '/campaigns/:any*',
  '/iframeSignIn'
]

const $ad = document.getElementById('ad-global-bottom-right');

$ad && ReactDOM.render(<AdGlobalPopad blacklist={adBlackList} />, document.getElementById('ad-global-bottom-right'))
